import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { JsonLd } from "@/components/JsonLd";
import { Faq } from "@/components/Faq";
import { AdSlot } from "@/components/AdSlot";
import { Card } from "@/components/ui/card";
import PortionsRechner from "@/components/portionen/PortionsRechner";
import { PORTION_SEITEN, PORTION_HUB } from "@/lib/portionenSeiten";

export default function PortionHubPage() {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const canonical = origin ? `${origin}/${PORTION_HUB.slug}` : undefined;

  const jsonLd = [
    {
      "@context": "https://schema.org", "@type": "WebApplication",
      name: "Portionsrechner", url: canonical, applicationCategory: "UtilityApplication",
      operatingSystem: "Web", offers: { "@type": "Offer", price: "0", priceCurrency: "EUR" }, inLanguage: "de-DE",
    },
    {
      "@context": "https://schema.org", "@type": "FAQPage",
      mainEntity: PORTION_HUB.faq.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
    },
  ];

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
      <Seo title={PORTION_HUB.title} description={PORTION_HUB.description} canonical={canonical} />
      <JsonLd data={jsonLd} />
      <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight">{PORTION_HUB.h1}</h1>
      <p className="mt-3 text-muted-foreground leading-relaxed">
        Wähle das Lebensmittel und die Personenzahl, der Rechner zeigt dir die passende Menge, roh in Gramm, als Beilage oder Hauptgericht. Praktisch fürs Kochen für Gäste.
      </p>
      <div className="mt-6"><PortionsRechner food="reis" /></div>
      <div className="mt-8"><AdSlot variant="banner" /></div>
      <section className="mt-8">
        <h2 className="text-xl font-semibold mb-3">Direkt zum Lebensmittel</h2>
        <div className="grid sm:grid-cols-2 gap-3">
          {PORTION_SEITEN.map((s) => (
            <Link key={s.slug} to={`/${s.slug}`} className="block">
              <Card className="p-4 h-full hover:shadow-md transition-shadow">
                <div className="font-semibold text-sm">{s.h1}</div>
                <div className="text-sm text-muted-foreground mt-1">{s.description}</div>
              </Card>
            </Link>
          ))}
        </div>
      </section>
      <section className="mt-10">
        <h2 className="text-xl font-semibold mb-4">Häufige Fragen</h2>
        <Faq items={PORTION_HUB.faq} testId="portion-hub-faq" />
      </section>
      <div className="mt-10"><AdSlot variant="banner" /></div>
    </div>
  );
}
